import type { IconNode } from '../types';

/**
 * @name house-roof-off
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIgNi44IDYuNiA2LjZhMiAyIDAgMCAwIDIuOC0yLjhsLTgtOGMtLjgtLjgtMi0uOC0yLjggMEw5LjIgNCIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Im02LjYgNi42LTQgNGEyIDIgMCAwIDAgMi44IDIuOGw0LTQiIC8+CiAgPHBhdGggZD0iTTE0IDIydi02YTIgMiAwIDAgMC00IDB2NiIgLz4KICA8cGF0aCBkPSJNNCAxNHY2YTIgMiAwIDAgMCAyIDJoMTJhMiAyIDAgMCAwIDItMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/house-roof-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const houseRoofOff: IconNode = [
  ['path', { d: 'm12 6.8 6.6 6.6a2 2 0 0 0 2.8-2.8l-8-8c-.8-.8-2-.8-2.8 0L9.2 4', key: '1hfpqv' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'm6.6 6.6-4 4a2 2 0 0 0 2.8 2.8l4-4', key: 's0innu' }],
  ['path', { d: 'M14 22v-6a2 2 0 0 0-4 0v6', key: '18j3a0' }],
  ['path', { d: 'M4 14v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2', key: '2z6e5c' }],
];

export default houseRoofOff;
